import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVolumeFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVolumeFull"><Path d="M15.8892 8.11133C16.8845 9.10663 17.5001 10.4816 17.5001 12.0004C17.5001 13.5192 16.8845 14.8942 15.8892 15.8895M19.4246 4.57544C21.3247 6.47557 22.4999 9.10057 22.4999 12.0001C22.4999 14.8996 21.3247 17.5246 19.4246 19.4247M1.5 7.5H6L12.5 3.75V20.25L6 16.5H1.5V7.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconVolumeFull;
